<template>
    <div class="section">
        <div class="columns is-centered is-multiline">
            <div class="column is-full">
                <p class="title is-size-4">Tienes un codigo de descuento?</p>
                <CouponInput
                :totalAmount="amountUsd"
                :couponFind="couponFind"
                @clearCoupon="clearCouponHandler"
                @couponCodeFound="couponHandler"/>
                <p class="is-size-4 title">Elige como vas a pagar la orden</p>
                <b-field v-if="transferBool" class="m-b-5" message="Te daremos los datos para que hagas el pago por tu cuenta (sujeto a validacion manual).">
                    <b-radio
                        v-model="data.method"
                        type="is-info"
                        native-value="transfer">
                        <strong>Transferencia bancaria</strong>
                    </b-radio>
                </b-field>
                <hr v-if="transferBool">
                <b-field v-if="cashBool" class="m-b-10" message="Te daremos los datos para que hagas el pago por tu cuenta (sujeto a validacion manual).">
                    <b-radio
                        v-model="data.method"
                        type="is-info"
                        native-value="cash">
                        <strong>Pagos presenciales <span v-if="cashChannels.length">(<span v-for="x in cashChannels" :key="x.id">{{x.title}}, </span>)</span></strong>
                    </b-radio>
                </b-field>
                <b-field v-if="mpBool">
                    <b-radio
                        v-model="data.method"
                        type="is-info"
                        native-value="mp">
                        <strong>Mercadopago (Tarjetas y dinero de Mercadopago.)</strong>
                    </b-radio>
                </b-field>
                <b-field v-if="bambooChannel == 'True'">
                    <b-radio
                        v-model="data.method"
                        type="is-info"
                        native-value="bp">
                        <strong>Pagar online</strong>
                    </b-radio>
                    <b-select
                    v-model="data.bambooMethod"
                    :disabled="disableBambooMethod">
                        <option v-for="x in bambooMethods" :key="x.id" :value="x.bambooId">{{x.title}}</option>
                    </b-select>
                </b-field>
            </div>
        </div>  
        <div class="container m-b-20">
            <div class="level is-mobile">
                <div class="level-item">
                    <div>
                        <p class="heading">Subtotal $UY</p>
                        <h3 class="">$UY{{cartDetail.totalInUy}}</h3>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading">Envio $UY</p>
                        <h3 class="">$UY{{data.shipmentTotalUy}}</h3>
                    </div>
                </div>
                <div class="level-item" v-if="data.discountUy" >
                    <div>
                        <p class="heading">Descuento $UY</p>
                        <h3 class="">$UY{{data.discountUy}}</h3>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading"><strong>Total $UY</strong></p>
                        <h3 class=""><strong>$UY{{data.amountUy}}</strong></h3>
                    </div>
                </div>
                
            </div>
        </div>  
        <hr>
        <div v-if="usdReportsBool" class="container m-b-20">
                <div class="level is-mobile">
                <div class="level-item">
                    <div>
                        <p class="heading">Subotal $USD</p>
                        <h3 class="">$USD{{cartDetail.totalInUsd}}</h3>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading">Envio $USD</p>
                        <h3 class="">$USD{{data.shipmentTotalUsd}}</h3>
                    </div>
                </div>
                <div class="level-item" v-if="data.discountUsd">
                    <div>
                        <p class="heading">Descuento $USD</p>
                        <h3 class="">$USD{{data.discountUsd}}</h3>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading"><strong>Total $USD</strong></p>
                        <h3 class=""><strong>$USD{{data.amountUsd}}</strong></h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-centered is-multiline m-t-30">
            <p v-if="manualOrderValidation && ['mp', 'pp'].includes(data.method)">
                Te redireccionaremos a la pagina de pago. Luego de que completes el proceso volveras a nuestro sitio.

            </p>
            <p v-else-if="manualOrderValidation && !['mp', 'pp'].includes(data.method)">
                Te enviaremos por email la info para realizar el pago, luego de que validemos la orden.
            </p>
            


            <div class="column is-full has-text-centered ">
                <b-button
                type="is-custom"
                rounded
                :disabled="!data.method.length"
                @click="continueStep">
                Crear orden
                <b-icon icon="arrow-right" size="is-small"></b-icon>
                </b-button>
            </div>

        </div>
    </div>
</template>

<script>
import CouponInput from "./CouponInput"
export default {
    components:{
        CouponInput
    },
    props:{
        cartDetail:{
            type:Object,
            default:new Object({})
        },
        mpBool:{
            type:Boolean,
            default:false
        },
        cashBool:{
            type:Boolean,
            default:false
        },
        paypalBool:{
            type:Boolean,
            default:false
        },
        transferBool:{
            type:Boolean,
            default:false
        },
        mpPubKey:{
            type:String,
            default:""
        },
        manualValidation:{
            type:String,
            default:""
        },
        amountUy:{
            type:Number,
            default:0
        },
        amountUsd:{
            type:Number,
            default:0
        },
        shipmentTotalUy:{
            type:Number,
            default:0
        },
        shipmentTotalUsd:{
            type:Number,
            default:0
        },
        couponFind:{
            type:String,
            default:""
        },
        mpMinOrder:{
            type:String,
            default:""
        },
        ppMinOrder:{
            type:String,
            default:""
        },
        usdReportsBool:{
            type:Boolean,
            default:false
        },
        channels:{
            type: Array,
            default: new Array([])
        },
        bambooChannel:{
            type:String,
            default:""
        },
        bambooClientId:{
            type:String,
            default:""
        },
        bambooKey:{
            type:String,
            default:""
        },
        bambooMethods:{
            type:Array,
            default: new Array([])
        }
    },
    data(){
        return{
            data:{
                method:"",
                shipmentTotalUy:this.shipmentTotalUy,
                shipmentTotalUsd:this.shipmentTotalUsd,
                amountUy:this.amountUy,
                amountUsd:this.amountUsd,
                discountUy:0,
                discountUsd:0,
                cotizacionUsd:this.cartDetail.usdVal,
                bambooMethod:false
            },
            renderedPaypal:false,
            cashChannels:[],
            
        }
    },
    methods:{
        couponHandler(data){
            this.data.discountCode = data.id
            if (data.discountFixed !=0 ){
                this.data.discountUy = data.discountFixedUy
                this.data.discountUsd = data.discountFixedUsd
                this.data.amountUy = this.amountUy - data.discountFixedUy
                this.data.amountUsd = this.amountUsd - data.discountFixedUsd
            }else if(data.discountPercent !=0 ){
                var discountP = parseFloat(parseFloat(data.discountPercent / 100).toFixed(2))
                this.data.discountUy = parseFloat(parseFloat(this.amountUy * discountP).toFixed(2))
                this.data.discountUsd = parseFloat(parseFloat(this.amountUsd * discountP).toFixed(2))
                this.data.amountUy = parseFloat(parseFloat(this.amountUy - this.data.discountUy).toFixed(2))
                this.data.amountUsd = parseFloat(parseFloat(this.amountUsd - this.data.discountUsd).toFixed(2))
            }
        },
        clearCouponHandler(data){
            this.data.discountCode = null
            this.data.discountUy = 0
            this.data.discountUsd = 0
            this.data.amountUy = this.amountUy
            this.data.amountUsd = this.amountUsd
        },
        continueStep(){
            this.$emit("payment", this.data)
        },

    },
    computed:{
        manualOrderValidation(){
            return this.manualValidation == "True"
        },
        mpMin(){
            return parseInt(this.mpMinOrder)
        },
        ppMin(){
            return parseInt(this.ppMinOrder)
        },
        disableBambooMethod(){
            console.log(this.data.method)
            console.log(this.data.method=="bp")
            if(this.data.method == "" || this.data.method == undefined){
                return true
            } else{
                return this.data.method != "bp"
            }
            
        }
    },
    watch:{
        cartDetail: function(val){
            this.data.cotizacionUsd = this.cartDetail.usdVal
            this.data.orderTotalUy = this.cartDetail.totalInUy
            this.data.orderTotalUsd = this.cartDetail.totalInUsd
        },
        shipmentTotalUsd: function(val){
            this.data.shipmentTotalUy=this.shipmentTotalUy
            this.data.shipmentTotalUsd=this.shipmentTotalUsd
            
        },
        shipmentTotalUy: function(val){
            this.data.shipmentTotalUy=this.shipmentTotalUy
            this.data.shipmentTotalUsd=this.shipmentTotalUsd
        },
        amountUsd: function(val){
            this.data.amountUsd = this.amountUsd - this.data.discountUsd
            this.data.amountUy = this.amountUy - this.data.discountUy
        },
        amountUy: function(val){
            this.data.amountUsd = this.amountUsd - this.data.discountUsd
            this.data.amountUy = this.amountUy - this.data.discountUy
        },
        channels: function(val){
            this.cashChannels = this.channels.filter(
                el=>{
                    return el.method == 'cash'
                }
            )
            this.transferChannels = this.channels.filter(
                el=>{
                    return el.method == 'transfer'
                }
            )
        }

    },
    created(){
        this.data = {
            method:"",
            shipmentTotalUy:this.shipmentTotalUy,
            shipmentTotalUsd:this.shipmentTotalUsd,
            amountUy:this.amountUy,
            amountUsd:this.amountUsd,
            discountUy:0,
            discountUsd:0,
            cotizacionUsd:this.cartDetail.usdVal
        }
    },
    
    
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

.transition{
    transition: all 1000ms;
}


.paypal-buttons{
    position: relative; 
    z-index: 1;
}


</style>